import { TransactionApprovalType } from '@portal/enum/approvalsType';
import { TransactionApprovalsPostType } from '@portal/models/module';
import { getInstance } from '@portal/repositories/securitySdkConfig';

const ApproveTransaction = {
  approvalsTransaction: async (
    type: TransactionApprovalType,
    id: string,
    pin: string
  ) => {
    const instance = getInstance();
    const { data } = await instance.patch(
      '/v3/transaction-request-pending-approval/change-status',
      {
        type,
        transactionRequestPendingApprovalId: id,
        authenticate: {
          pin,
        },
      }
    );

    return data;
  },

  approvalsMultipleTransaction: async (
    params: TransactionApprovalsPostType
  ) => {
    const instance = getInstance();
    const { data } = await instance.patch(
      `/v3/transaction-request-pending-approval/change-status-bulk`,
      { ...params }
    );

    return data;
  },

  getTransaction: async (
    params: advancedFilterModels.ApprovalTransactionFilter
  ) => {
    const instance = getInstance();

    const { data } = await instance.get(
      `V3/transaction-request-pending-approval`,
      {
        params,
      }
    );

    return data;
  },

  getByIdTransaction: async (id?: string) => {
    const instance = getInstance();
    const { data } = await instance.get(
      `V3/transaction-request-pending-approval/${id}`
    );

    return data;
  },
};

export default ApproveTransaction;
